// extracted by mini-css-extract-plugin
export default {"iconWrapper":"_-_-record-it-components-src-cardList-CardListItemIconButton-__iconWrapper"};